import { useState, createContext, useContext, useEffect } from "react";

import { newDiscussion, addComment, loadDiscussions, toggleLike, toggleUnlike, removeComment, removeDiscussion, updateDiscussion } from "./global-medic.services";
import { uploadFile, deleteFileFromServer } from "../documents/documents.context";

export const GlobalMedicContext = createContext();

export const GlobalMedicContextProvider = ({ children }) => {


    const [allDiscussions, setAllDiscussions] = useState([]);

    //create new discussion
    const createNewDiscussion = async (data, token) => {
        try {
            if (data.imageFile) {
                const filepath = await uploadFile({
                    document: data.imageFile
                });
                const response = await newDiscussion({
                    ...data,
                    media: {
                        image: filepath
                    }
                }, token);
                const res = await response.json();
                console.log(res);
                return res;
            } else {
                const response = await newDiscussion(data, token);
                const res = await response.json();
                console.log(res);
                return res;
            }
        } catch (error) {
            console.log({ error });
        }
    }



    //like discussion
    /**
     * 
     * @param {string} id 
     * @param {string} token 
     * @returns {object} //discussion
     */
    const toggleLikeDiscussion = async (id, token) => {
        try {
            const response = await toggleLike(id, token);
            const resp = await response.json();
            return resp;
        } catch (error) {
            console.log({ error });
        }
    }

    //unlike discussion
    /**
     * 
     * @param {string} id 
     * @param {string} token 
     * @returns 
     */
    const toggleUnlikeDiscussion = async (id, token) => {
        try {
            const response = await toggleUnlike(id, token);
            const resp = await response.json();
            return resp;
        } catch (error) {
            console.log({ error });
        }
    }

    //comment a discussion
    const commentDiscussion = async (data, id, token) => {
        try {
            if (data.imageFile) {
                const filepath = await uploadFile({
                    document: data.imageFile
                });
                const response = await addComment(
                    {
                        ...data,
                        media: {
                            image: filepath
                        },
                        parentId: id
                    }, token);
                const res = await response.json();
                console.log(res);
                return res;
            } else {
                const response = await addComment({ ...data, parentId: id }, token);
                const res = await response.json();
                console.log(res);
                return res;
            }
        } catch (error) {
            console.log({ error });
        }
    }



    /** update a discussion */
    const editDiscussionData = async (data, id, token) => {
        try {
            if (data.oldImage) {
                await deleteFileFromServer(data.oldImage);
            }
            if (data.imageFile) {
                const filepath = await uploadFile({
                    document: data.imageFile
                });
                const response = await updateDiscussion({
                    ...data,
                    media: {
                        image: filepath
                    }
                }, id, token);
                const res = await response.json();
                //console.log(res);
                return res;
            } else {
                if (data.oldImage) {
                    const response = await updateDiscussion({
                        ...data,
                        media: {
                            image: null
                        }
                    }, id, token);
                    const res = await response.json();
                    //console.log(res);
                    return res;
                }
                const response = await updateDiscussion(data, id, token);
                const res = await response.json();
                console.log(res);
                return res;
            }
        } catch (error) {
            console.log({ error });
        }
    }

    /** delete comment */
    const deleteComment = async (id, token) => {
        try {
            console.log(id, token)
            const response = await removeComment(id, token);
            const resp = await response.json();
            console.log(resp);
            return resp;
        } catch (error) {
            console.log({ error });
        }
    }

    /** delete discussion */
    const deleteDiscussion = async (token, id) => {
        try {
            const response = await removeDiscussion(token, id);
            const res = await response.json();
            return res;
        } catch (error) {
            console.log({ error });
        }
    }

    useEffect(() => {
        //fetch all discussions
        const getAllDiscussions = async () => {
            try {
                const response = await loadDiscussions();
                const res = await response.json();
                return res;
            } catch (error) {
                console.log({ error });
            }
        }
        (async () => {
            const resp = await getAllDiscussions();
            setAllDiscussions(resp);
        })();
    }, [])

    return (
        <GlobalMedicContext.Provider
            value={{
                createNewDiscussion,
                updateDiscussion,
                loadDiscussions,
                deleteDiscussion,
                commentDiscussion,
                editDiscussionData,
                toggleLikeDiscussion,
                deleteComment,
                toggleUnlikeDiscussion,
                allDiscussions
            }}
        >
            {children}
        </GlobalMedicContext.Provider>
    )
}


export const useGlobalMedic = () => useContext(GlobalMedicContext);
